import Link from "next/link";

import { BreadcrumbJsonLd } from "next-seo";

import { SITE_DOMAIN } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { BlogBreadcrumbsProps, BreadcrumbItem } from "@/types/blog-post";

const BlogBreadcrumbs = ({ className, pageSlug, pageTitle }: BlogBreadcrumbsProps) => {
  const breadcrumbItems: BreadcrumbItem[] = [
    {
      position: 1,
      name: "Home",
      item: SITE_DOMAIN,
    },
    {
      position: 2,
      name: "Resources",
      item: `${SITE_DOMAIN}/resources`,
    },
    {
      position: 3,
      name: pageTitle,
      item: `${SITE_DOMAIN}/resources/${pageSlug}`,
    },
  ];

  return (
    <div className={cn("w-full", className)}>
      <BreadcrumbJsonLd itemListElements={breadcrumbItems} />
      <nav aria-label="Breadcrumb" className="mx-auto">
        <ol className="flex flex-wrap items-center gap-2 text-sm text-ash-500">
          <li>
            <Link href="/" className="hover:text-ash-700">
              Home
            </Link>
          </li>
          <li className="select-none">/</li>
          <li>
            <Link href="/resources" className="hover:text-ash-700">
              Resources
            </Link>
          </li>
          <li className="select-none">/</li>
          <li className="text-ash-900 line-clamp-1">{pageTitle}</li>
        </ol>
      </nav>
    </div>
  );
};

export default BlogBreadcrumbs;
